export const LOADER_SERVICES = {
  lifting: "спуск/подъём",
  assembly: "сборка/разборка"
};
